import {SmartComponent} from "smart-component-js";
import Swiper, {Navigation, Pagination, Autoplay} from "swiper";

class CarouselComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.init();
    }

    init() {
        if (typeof Swiper === "undefined") {
            console.error(
                "Swiper non è definito. Assicurati di aver incluso il file JS di Swiper tramite CDN."
            );
            return;
        }

        const swiperContainer = this.element.querySelector(
            ".carousel-component__swiper"
        );

        this.swiper = new Swiper(swiperContainer, {
            loop: true,
            spaceBetween: 24,
            centeredSlides: true,
            slideActiveClass: "swiper-slide-active",
            modules: [Navigation, Pagination, Autoplay],
            navigation: {
                nextEl: ".carousel-component__button--next",
                prevEl: ".carousel-component__button--prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            autoplay: {
                delay: 5000,
            },
            slidesPerView: 1,
            watchSlidesProgress: true,
            breakpoints: {
                1024: {
                    slidesPerView: 1.8
                },
                768: {
                    slidesPerView: 1.2,
                    centeredSlides: false
                }
            },
            on: {
                init: () => swiperContainer.classList.add('loaded'),
            }
        });
    }
}

export default CarouselComponent;
